import produce from 'immer'
import React, { useEffect, useState } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import Select from 'react-select'
import AdministrativeArea from '../../../components/common/administrativeAreaWithRedux/AdministrativeArea'
import LoadingComponent from '../../../components/common/loading/LoadingComponent'
import { RoleIdModel } from '../../../models/user/roleIdModel'
import { RoleListModal } from '../../../models/user/roleListModel'
import { UserModal } from '../../../models/usermanagement/userModel'
import metaDataService from '../../../services/metaDataService'
import {
  provinceFetchRequest,
  districtFetchRequest,
  dsFetchRequest,
  gnFetchRequest,
  clearAdminsitrativeAreeLisRequest,
} from '../../../store/administrativeArea/actions'
import userManagementService from '../../../services/userManagementService'
import { getSelectedDsList } from '../../../store/administrativeArea/selectors'
import * as constants from '../../../utils/constants'
import './AddUserComponent.scss'
import { showTotast } from '../../../utils/toast'
import * as errorMessages from '../../../utils/errorMessages'
import ConfirmationModal from '../../../components/modals/ConfirmationModal'
import { FormErrorModel } from '../../../models/user/formErrorModel'
import * as validation from './validations'
import { userCreate } from '../../../utils/successMessages'
import { IRole } from '../../../store/usermanagement/actionTypes'
import { changeLoadingRequest } from '../../../store/app/actionTypes'
import { DSListModel } from '../../../models/administrativeArea/dsListModel'
import { DSDivisionModal } from '../../../models/administrativeArea/dsDivisionModal'
const initiateUserModel = { createUserPsychosocial: true } as UserModal

const AddUserComponent = () => {
  const [loading, setloading] = useState(true)
  const [isSubmi, setIsSubmi] = useState(false)
  const [isValid, setisValid] = useState(true)
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [designationList, setDesignationList] = useState([])
  const [organizationList, setOrganizationList] = useState([])
  const [titleList, setTitleList] = useState([])
  const roleOption: constants.RoleOption[] = []
  const [roleOptions, setRoleOptions] = useState(roleOption)
  const [user, setuser] = useState(initiateUserModel)
  const [errors, setErrors] = useState({} as FormErrorModel)
  const dsList = useSelector(getSelectedDsList)
  const history = useHistory()
  const dispatch = useDispatch()
  useEffect(() => {
    async function getMetaData() {
      dispatch(provinceFetchRequest())
      dispatch(districtFetchRequest())
      dispatch(dsFetchRequest())
      dispatch(gnFetchRequest())
      const designatationData = await metaDataService.apiDesignationFetch()
      const organizationData = await metaDataService.apiOrganizationFetch()
      const titleData = await metaDataService.apiTitleListFetch()
      const roleData = await metaDataService.apiGetRolesList()
      const activatedRoles = roleData.data.filter((role: IRole) => {
        return role.status == 'Active'
      })
      setDesignationList(designatationData.data)
      setOrganizationList(organizationData.data)
      setTitleList(titleData.data)
      const roleOptionList: constants.RoleOption[] = []
      for (let i = 0; i < activatedRoles.length; i++) {
        const roleOption: constants.RoleOption = {
          value: activatedRoles[i].id,
          label: activatedRoles[i].name,
        }
        roleOptionList.push(roleOption)
      }
      setRoleOptions(roleOptionList)
      setloading(false)
    }
    getMetaData()
    return () => {
      dispatch(clearAdminsitrativeAreeLisRequest())
    }
  }, [])

  const findFormErrors = () => {
    const newErrors = {} as FormErrorModel
    if (validation.validateTitle(user.title)) {
      newErrors.titleError = validation.validateTitle(user.title)
    }
    if (validation.validatefirstName(user.firstName)) {
      newErrors.firstNameError = validation.validatefirstName(user.firstName)
    }
    if (validation.validatelastName(user.lastName)) {
      newErrors.lastNameError = validation.validatelastName(user.lastName)
    }
    if (validation.validateEpfNumber(user.epfNumber)) {
      newErrors.epfNumberError = validation.validateEpfNumber(user.epfNumber)
    }
    if (validation.validateEmail(user.email)) {
      newErrors.emailError = validation.validateEmail(user.email)
    }
    if (validation.validateMobileNumber(user.mobileNumber)) {
      newErrors.mobileNumberError = validation.validateMobileNumber(
        user.mobileNumber
      )
    }
    if (validation.validateOrganization(user.organizationId)) {
      newErrors.organizationError = validation.validateOrganization(
        user.organizationId
      )
    }
    if (validation.validateDesignation(user.designation)) {
      newErrors.designationError = validation.validateDesignation(
        user.designation
      )
    }
    if (validation.validateRoleList(user.roleList)) {
      newErrors.roleListError = validation.validateRoleList(user.roleList)
      setisValid(false)
    }
    if (validation.validateAdministrativeAreaList(dsList)) {
      newErrors.userAdministrativeAreasError =
        validation.validateAdministrativeAreaList(dsList)
    }

    return newErrors
  }

  useEffect(() => {
    if (dsList.length === 0 && isSubmi) {
      const clearError = produce(errors, (draft) => {
        draft.userAdministrativeAreasError =
          errorMessages.administrativeAreaListEmpty
      })
      setErrors(clearError)
    } else if (dsList.length > 0) {
      const clearError = produce(errors, (draft) => {
        draft.userAdministrativeAreasError = ''
      })
      setErrors(clearError)
    }
  }, [dsList])
  const customStyles = {
    control: (base: any, state: { isFocused: any }) => ({
      ...base,
      // state.isFocused can display different borderColor if you need it
      borderColor: state.isFocused ? '#ddd' : isValid ? '#ddd' : 'red',
      // overwrittes hover style
      '&:hover': {
        borderColor: state.isFocused ? '#ddd' : isValid ? '#ddd' : 'red',
      },
    }),
  }
  const handleMultiselct = (selectedOption: any) => {
    const selectedRoles: RoleListModal[] = []
    for (let i = 0; i < selectedOption.length; i++) {
      const roleObject = { role: {} as RoleIdModel } as RoleListModal
      roleObject.role.id = selectedOption[i].value

      selectedRoles.push(roleObject)
    }
    const newUser = produce(user, (draft: UserModal) => {
      draft.roleList = selectedRoles
    })
    setuser(newUser)
  }
  const buttonClickSubmit = async () => {
    setIsSubmi(true)
    const dsListArray: DSListModel[] = []
    for (let i = 0; i < dsList.length; i++) {
      const dsListObject = {
        dsDivision: {} as DSDivisionModal,
      } as DSListModel
      dsListObject.dsDivision.id = dsList[i].id
      dsListArray.push(dsListObject)
    }

    const newGnlist = produce(user, (draft: UserModal) => {
      draft.administrativeAreaList = dsListArray
    })
    setuser(newGnlist)
    const foundErrros = findFormErrors()
    if (Object.keys(foundErrros).length > 0) {
      setErrors(foundErrros)
      debugger
      showTotast(
        constants.ALERT_WARNING,
        errorMessages.validationError,
        constants.TOAST_POSITION_TOP_RIGHT,
        5,
        constants.TOAST_TRANSITION_SLIDE
      )
    } else {
      setErrors(foundErrros)
      setShowConfirmation(true)
    }
  }
  const handleConfirm = async () => {
    document.getElementById('confirmation-ok').disabled = true
    setShowConfirmation(false)
    dispatch(changeLoadingRequest())
    const result = await userManagementService.apiUserCreate(user)
    dispatch(changeLoadingRequest())
    let success = false
    let message = result.errorMessage ? result.errorMessage : ''
    if (result.status === 200) {
      setloading(true)
      success = true
      message = userCreate
      history.goBack()
    }
    showTotast(
      success ? constants.ALERT_SUCCESS : constants.ALERT_WARNING,
      message,
      constants.TOAST_POSITION_TOP_RIGHT,
      5,
      constants.TOAST_TRANSITION_SLIDE
    )
  }
  const handleBack = () => {
    history.goBack()
  }

  return (
    <>
      {loading ? (
        <Container className="loading-layout">
          <LoadingComponent />
        </Container>
      ) : (
        <Row className="create-user-page-layout">
          <Col sm={12} className="border-label">
            <div className="border-label-span">Add User</div>
            <Form>
              <Form.Group className="mb-3" controlId="formGroupTitle">
                <Form.Label>
                  Title <span className="required-field-astrix">*</span>
                </Form.Label>
                <Form.Control
                  isInvalid={!!errors.titleError}
                  onBlur={(e) => {
                    const newError = produce(errors, (draft) => {
                      draft.titleError = validation.validateTitle(
                        e.target.value
                      )
                    })
                    setErrors(newError)
                  }}
                  className="form-select"
                  as="select"
                  onChange={(e) => {
                    const newFormValue = produce(user, (draft: UserModal) => {
                      draft.title = e.target.value
                    })
                    setuser(newFormValue)
                    const clearError = produce(errors, (draft) => {
                      draft.titleError = ''
                    })
                    setErrors(clearError)
                  }}
                >
                  {!user.title ? (
                    <option value="">--Select Title--</option>
                  ) : (
                    ''
                  )}
                  {titleList.map(
                    (title: { name: string; id: number }, index: number) => {
                      return (
                        <option key={`country-${index}`} value={title.name}>
                          {title.name}
                        </option>
                      )
                    }
                  )}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.titleError}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupFirstName">
                <Form.Label>
                  First Name <span className="required-field-astrix">*</span>
                </Form.Label>
                <Form.Control
                  isInvalid={!!errors.firstNameError}
                  placeholder="Enter First Name"
                  onBlur={(e) => {
                    const newError = produce(errors, (draft) => {
                      draft.firstNameError = validation.validatefirstName(
                        e.target.value
                      )
                    })
                    setErrors(newError)
                  }}
                  type="text"
                  onChange={(e) => {
                    const newFormValue = produce(user, (draft: UserModal) => {
                      draft.firstName = e.target.value
                    })
                    setuser(newFormValue)
                    const clearError = produce(errors, (draft) => {
                      draft.firstNameError = ''
                    })
                    setErrors(clearError)
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.firstNameError}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupLastName">
                <Form.Label>
                  Last Name <span className="required-field-astrix">*</span>
                </Form.Label>
                <Form.Control
                  isInvalid={!!errors.lastNameError}
                  onBlur={(e) => {
                    const newError = produce(errors, (draft) => {
                      draft.lastNameError = validation.validatelastName(
                        e.target.value
                      )
                    })
                    setErrors(newError)
                  }}
                  placeholder="Enter Last Name"
                  type="text"
                  onChange={(e) => {
                    const newFormValue = produce(user, (draft: UserModal) => {
                      draft.lastName = e.target.value
                    })
                    setuser(newFormValue)
                    const clearError = produce(errors, (draft) => {
                      draft.lastNameError = ''
                    })
                    setErrors(clearError)
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.lastNameError}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupEPFNumber">
                <Form.Label>
                  EPF Number <span className="required-field-astrix">*</span>
                </Form.Label>
                <Form.Control
                  isInvalid={!!errors.epfNumberError}
                  onBlur={(e) => {
                    const newError = produce(errors, (draft) => {
                      draft.epfNumberError = validation.validateEpfNumber(
                        e.target.value
                      )
                    })
                    setErrors(newError)
                  }}
                  placeholder="Enter EPF Number"
                  type="text"
                  value={user.epfNumber}
                  onChange={(e) => {
                    const re = /^[0-9\b]+$/

                    if (re.test(e.target.value)) {
                      const newFormValue = produce(user, (draft: UserModal) => {
                        draft.epfNumber = e.target.value
                      })
                      setuser(newFormValue)
                      const clearError = produce(errors, (draft) => {
                        draft.epfNumberError = ''
                      })
                      setErrors(clearError)
                    } else {
                      const newFormValue = produce(user, (draft: UserModal) => {
                        draft.epfNumber = ''
                      })
                      setuser(newFormValue)
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.epfNumberError}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupEmailAddress">
                <Form.Label>
                  Email Address <span className="required-field-astrix">*</span>
                </Form.Label>
                <Form.Control
                  isInvalid={!!errors.emailError}
                  onBlur={(e) => {
                    const newError = produce(errors, (draft) => {
                      draft.emailError = validation.validateEmail(
                        e.target.value
                      )
                    })
                    setErrors(newError)
                  }}
                  placeholder="Enter Email Address"
                  type="text"
                  onChange={(e) => {
                    const newFormValue = produce(user, (draft: UserModal) => {
                      draft.email = e.target.value
                    })
                    setuser(newFormValue)
                    const clearError = produce(errors, (draft) => {
                      draft.emailError = ''
                    })
                    setErrors(clearError)
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.emailError}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupMobileNumber">
                <Form.Label>
                  Mobile Number <span className="required-field-astrix">*</span>
                </Form.Label>
                <Form.Control
                  maxLength={15}
                  onBlur={(e) => {
                    const newError = produce(errors, (draft) => {
                      draft.mobileNumberError = validation.validateMobileNumber(
                        e.target.value
                      )
                    })
                    setErrors(newError)
                  }}
                  isInvalid={!!errors.mobileNumberError}
                  placeholder="Enter Mobile Number"
                  type="text"
                  onChange={(e) => {
                    const newFormValue = produce(user, (draft: UserModal) => {
                      draft.mobileNumber = e.target.value
                    })
                    setuser(newFormValue)
                    const clearError = produce(errors, (draft) => {
                      draft.mobileNumberError = ''
                    })
                    setErrors(clearError)
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.mobileNumberError}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupOrganization">
                <Form.Label>
                  Organization <span className="required-field-astrix">*</span>
                </Form.Label>
                <Form.Control
                  isInvalid={!!errors.organizationError}
                  onBlur={(e) => {
                    const newError = produce(errors, (draft) => {
                      draft.organizationError = validation.validateOrganization(
                        parseInt(e.target.value)
                      )
                    })
                    setErrors(newError)
                  }}
                  className="form-select"
                  as="select"
                  onChange={(e) => {
                    const newFormValue = produce(user, (draft: UserModal) => {
                      draft.organizationId = parseInt(e.target.value)
                    })
                    setuser(newFormValue)
                    const clearError = produce(errors, (draft) => {
                      draft.organizationError = ''
                    })
                    setErrors(clearError)
                  }}
                >
                  {!user.organizationId ? (
                    <option value="">--Select Organization--</option>
                  ) : (
                    ''
                  )}
                  {organizationList.map(
                    (org: { name: string; id: number }, index: number) => {
                      return (
                        <option key={`org-${index}`} value={org.id}>
                          {org.name}
                        </option>
                      )
                    }
                  )}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.organizationError}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupDesignation">
                <Form.Label>
                  Designation <span className="required-field-astrix">*</span>
                </Form.Label>
                <Form.Control
                  isInvalid={!!errors.designationError}
                  onBlur={(e) => {
                    const newError = produce(errors, (draft) => {
                      draft.designationError = validation.validateDesignation(
                        e.target.value
                      )
                    })
                    setErrors(newError)
                  }}
                  className="form-select"
                  as="select"
                  onChange={(e) => {
                    const newFormValue = produce(user, (draft: UserModal) => {
                      draft.designation = e.target.value
                    })
                    setuser(newFormValue)
                    const clearError = produce(errors, (draft) => {
                      draft.designationError = ''
                    })
                    setErrors(clearError)
                  }}
                >
                  {!user.designation ? (
                    <option value="">--Select Designation--</option>
                  ) : (
                    ''
                  )}
                  {designationList.map(
                    (dsg: { name: string; id: number }, index: number) => {
                      return (
                        <option key={`org-${index}`} value={dsg.name}>
                          {dsg.name}
                        </option>
                      )
                    }
                  )}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.designationError}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="Roles">
                <Form.Label>
                  Roles <span className="required-field-astrix">*</span>
                </Form.Label>
                <Select
                  styles={customStyles}
                  isMulti
                  placeholder="--Select Role--"
                  options={roleOptions}
                  onChange={(selectedOption) => {
                    handleMultiselct(selectedOption)
                    selectedOption.length === 0
                      ? setisValid(false)
                      : setisValid(true)
                    const newError = produce(errors, (draft) => {
                      draft.roleListError =
                        validation.validateRoleList(selectedOption)
                    })
                    setErrors(newError)
                  }}
                />
                <span className="feedback-error-span">
                  {errors.roleListError}
                </span>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formGroupAdminAreaList">
                <Form.Label>
                  Administrative Area List{' '}
                  <span className="required-field-astrix">*</span>
                </Form.Label>
                <br />
                <span className="feedback-error-span">
                  {errors.userAdministrativeAreasError}
                </span>
                <Row className="add-admin-area-list">
                  <Col sm={12}>
                    <AdministrativeArea />
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group>
                <Col>
                  <Form.Check
                    checked={user.createUserPsychosocial}
                    type="checkbox"
                    label="Create user in psycho-social system"
                    name="createUserPsychosocial "
                    onChange={(e) => {
                      const newFormValue = produce(user, (draft: UserModal) => {
                        draft.createUserPsychosocial = e.target.checked
                      })
                      setuser(newFormValue)
                    }}
                  />
                </Col>
              </Form.Group>
            </Form>
          </Col>
          <Col sm={12} className="d-flex justify-content-end mt-4">
            <button className="cancel-button" onClick={handleBack}>
              Cancel
            </button>
            <button
              type="submit"
              className="save-button"
              onClick={buttonClickSubmit}
            >
              Save
            </button>
          </Col>
          {showConfirmation && (
            <ConfirmationModal
              name={'Confirmation'}
              message={'Are you sure to create this user ?'}
              onCancel={() => {
                setShowConfirmation(false)
              }}
              onConfirm={handleConfirm}
            />
          )}
        </Row>
      )}
    </>
  )
}

export default AddUserComponent
